/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
	Layout,
	Menu,
	Popover,
	Button,
	Popconfirm,
	Dropdown,
	Space,
	Skeleton,
	Image, 
	Tag
} from "antd";
import { Link } from "react-router-dom";
import { FcLock } from "react-icons/fc";
import { TfiLock } from "react-icons/tfi";


import "../../Styles/styles-Header.css";
import Logo from "../../Images/newlogo1-01.png";
import { useDispatch } from "react-redux";
import "./Navbar.css";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import { logoutRedirectUrl } from "../../auth/auth0";
import { TeamSelectionMenu } from "./TeamSelectionMenu";

const { Header } = Layout;

const newTag = (<Tag color="processing" style={{borderRadius: '5px'}}>New</Tag>)

export const Navbar = () => {
	const { logout } = useAuth0();
	const location = useLocation();
	const navigate = useNavigate();
	const {
		info: { team_logo, dvai_enabled, scatterplot_enabled },
	} = useSelector(({ team }) => team);

	const {
		currentUser: { email },
	} = useSelector(({ auth }) => auth);

	const handleLogout = () => {
		logout({ logoutParams: { returnTo: logoutRedirectUrl } });
		localStorage.removeItem("team-id");
	};


	return (
		<>
			<div className="outer-navbar">
				<div className="navbar-navbar">
					<Layout className="layout" style={{width: '100%'}}>
						<Header
							style={{
								backgroundColor: "white",
								display: "flex",
								padding: 0,
								alignItems: "center",
								// justifyContent: "flex-start",
								// width: "100%",
							}}
						>
							
							<Menu
								theme="light"
								mode="horizontal"
								defaultSelectedKeys={[location?.pathname?.replace('/', '')]}
								selectedKeys={[location?.pathname?.replace('/', '')]}
								multiple={false}
								style={{ width: "95%"}}
								className="gpsdv-navbar"
							>
								<Menu.Item key='logo'><NavLink to="/overview"><img className="navbar-logo" src={Logo} alt="GPS DataViz"/></NavLink></Menu.Item>
								<Menu.Item key='overview'><NavLink to={"/overview"}>Overview</NavLink></Menu.Item>
								<Menu.Item key='status-tracker'><NavLink to={"/status-tracker"}>Status Tracker {newTag}</NavLink></Menu.Item>
								<Menu.Item key='upload-data'><NavLink to={"/upload-data"}>Upload</NavLink></Menu.Item>
								<Menu.Item key='teamdata'><NavLink to={"/teamdata"}>Team</NavLink></Menu.Item>
								<Menu.Item key='playerdata'><NavLink to={"/playerdata"}>Players</NavLink></Menu.Item>

								<Menu.SubMenu 
									key="breakdown-menu" 
									onTitleClick={() => {navigate('/breakdown')}}
									title={["breakdown-menu", "breakdown", "baseline", "drills"].includes(location?.pathname?.replace('/', '')) ? <b>Breakdown</b> : "Breakdown"} 
									>
									<Menu.Item key="breakdown"><NavLink to={"/breakdown"}>Daily Breakdown</NavLink></Menu.Item>
									<Menu.Item key="baseline"><NavLink to={"/baseline"}>Baselines</NavLink></Menu.Item>
									<Menu.Item key="drills"><NavLink to={"/drills"}>Drills</NavLink></Menu.Item>
								</Menu.SubMenu>

								<Menu.Item key="leaderboard"><NavLink to={"/leaderboard"}>Leaderboard</NavLink></Menu.Item>
								<Menu.Item key="scatterplot" icon={scatterplot_enabled ? null :<TfiLock/>}><NavLink to={"/scatterplot"}>Scatterplot</NavLink></Menu.Item>
								<Menu.Item key="compare"><NavLink to={"/compare"}>Compare</NavLink></Menu.Item>
								<Menu.Item key="reports"><NavLink to={"/reports"}>Reports</NavLink></Menu.Item>
								<Menu.Item key="chatbot" icon={dvai_enabled ? null :<TfiLock/>}><NavLink to={"/chatbot"}>DataViz AI</NavLink></Menu.Item>
								<Menu.Item key="settings"><NavLink to={"/settings"}>Team Settings</NavLink></Menu.Item>
								{/* Note: when adding/reorder tabs, make sure to update tab order list in HelpCenterPage.jsx */}
							</Menu>

							<div style={{ cursor: "pointer", marginRight: '5px' }}>
								<Popover
									placement="bottomRight"
									title={email}
									content={
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												margin: "-12px -16px",
											}}
										>
											<TeamSelectionMenu />
											<Space style={{ marginBottom: 16 }}>
												<Button type="primary">
													<Link to="/help-center">
														Help Center
													</Link>
												</Button>
												<Popconfirm
													placement="bottomRight"
													title="Are you sure?"
													onConfirm={handleLogout}
													okText="Yes"
													cancelText="No"
												>
													<Button type="primary">
														Logout
													</Button>
												</Popconfirm>
											</Space>
										</div>
									}
								>
									{team_logo ? (
										<Image
											id="team-logo"
											src={team_logo}
											width={60}
											preview={false}
										/>
									) : (
										<div>
											<Skeleton.Avatar
												active={true}
												size={"large"}
												style={{
													width: 60,
													height: 60,
												}}
											/>
										</div>
									)}
								</Popover>
							</div>
						</Header>
					</Layout>
				</div>
			</div>
		</>
	);
};
